import React, { Fragment, useState, useEffect, useContext } from 'react';
import { createPortal } from 'react-dom';
import getUrl from '../../src/getUrl';
import { get } from 'lodash';
import ReactTooltip from 'react-tooltip';
import { injectGlobal } from 'styled-components';
import { Dialog, DialogContent, TextField, Button, DialogTitle, Chip, Typography } from '@material-ui/core';
import { v4 as createUuid } from 'uuid';
import RichTextEditor from 'react-rte';
import isAdminContext from 'src/context/isAdminContext';


// Обновлять текст, когда другой элемент на странице с таким же id изменился
// Выхывать функцию isAdmin один раз в приложении
injectGlobal`.__react_component_tooltip {
  padding: 0; z-index: 100500;
}`;
export default function TranslateText({
  id,
  place = 'left',
  render,
  useHtml = false,
  controls = [],
  helperChips = {},
  hideTooltip = false,
  style = {},
  useTextImmitation = false,
}) {
  if (useTextImmitation && (useHtml || render)) {
    console.warn('TranslateText: check prop values, you cant use useTextImmitation with useHtml or render props');
  }

  const uuid = createUuid();
  const convertToValue = (text) => !useHtml ? text : RichTextEditor.createValueFromString(text, 'html');
  const convertToText = (value) => !useHtml ? value : value.toString('html');
  
  const [errorText, setErrorText] = useState('');
  const [value, setValue] = useState(convertToValue(''));
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [dialogueValue, setDialogueValue] = useState(convertToValue(''));
  
  const isAdmin = useContext(isAdminContext);

  useEffect(() => {
    fetch(getUrl(`/api/v1/dictionaries/fw/contents/${window.encodeURIComponent(id)}`), { credentials: 'include' })
      .then(res => res.json())
      .then(json => {
        const text = get(json, 'data.data[0].val', isAdmin ? 'Перевод не найден' : '');
        setValue(convertToValue(text));
      })
      .catch(console.error);
  }, []);


  const submitTranslate = (value) => {
    fetch(getUrl(`/api/v1/dictionaries/fw/contents/${window.encodeURIComponent(id)}`), {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      method: 'PUT',
      body: JSON.stringify({ val: value, code: id })
    })
      .then(() => {
        setDialogIsOpen(false);
      })
      .catch(console.error);
  };

  const convertedText = convertToText(value);
  const displayOutput = render ?
    render(convertedText)
    :
    (!useHtml ?
      !useTextImmitation ? convertedText : <span style={convertedText ? {} : { height: useTextImmitation, opacity: 0 }}>{convertedText || 'empty text'}</span>
      :
      <div dangerouslySetInnerHTML={{ __html: convertedText }} />
    );
    
  if (isAdmin && !hideTooltip) {
    return (
      <Fragment>
        {createPortal((
          <ReactTooltip
            place={place}
            type="dark"
            effect="solid"
            id={uuid}
            delayHide={150}
            clickable={true}
            overridePosition={({ left, top }) => ({ left: left + 6, top })}
          >
            <div
              style={{ cursor: 'pointer', padding: '8px 21px' }}
              onClickCapture={event => {
                event.stopPropagation();
                setDialogueValue(value);
                setDialogIsOpen(true);
              }}
            >
              Перевод
            </div>
          </ReactTooltip>
        ), document.body)}
        <div
          data-tip
          style={{ ...style }}
          data-for={uuid}
          // onMouseEnter={event => console.log('eneter')}
          // onMouseLeave={event => console.log('leave')}
          // onMouseMove={event => console.log('move')}
        >
          {displayOutput}
        </div>
        <Dialog
          open={dialogIsOpen}
          onClick={event => event.stopPropagation()}
          onClose={() => setDialogIsOpen(false)}
          maxWidth="lg"
        >
          <DialogTitle>Перевод</DialogTitle>
          {get(helperChips, 'labels') &&
            <Fragment>
              {helperChips.labels.map(label => {
                return (
                  <DialogContent>
                    <Chip label={label} />
                  </DialogContent>
                );
              })}
              {get(helperChips, 'example') && 
                <DialogContent>
                  <Typography variant="overline">Пример: </Typography>
                  <Typography variant="caption">{helperChips.example}</Typography>
                </DialogContent>
              }
            </Fragment>
          }
          <DialogContent>
            {!useHtml ?
              <TextField
                autoFocus
                fullWidth
                error={Boolean(errorText)}
                helperText={errorText}
                value={dialogueValue}
                onChange={({ target: { value }}) => {
                  if (value.trim().length) {
                    setErrorText('');
                  } else {
                    setErrorText('Введите текст');
                  }

                  setDialogueValue(value);
                }}
              />
              :
              <RichTextEditor
                autoFocus
                value={dialogueValue}
                onChange={value => {
                  const tmpDiv = document.createElement('div');
                  tmpDiv.innerHTML = value.toString('html');

                  if (tmpDiv.textContent.trim().length) {
                    setErrorText('');
                  } else {
                    setErrorText('Введите текст');
                  }

                  setDialogueValue(value);
                }}
                toolbarConfig={{
                  display: [
                    ...(controls.includes('bold') ? ['INLINE_STYLE_BUTTONS'] : []),
                    ...(controls.includes('ol') || controls.includes('ul') ? ['BLOCK_TYPE_BUTTONS'] : []),
                    ...(controls.includes('img') ? ['IMAGE_BUTTON'] : []),
                  ],
                  INLINE_STYLE_BUTTONS: [
                    ...(controls.includes('bold') ? [{ label: 'Bold', style: 'BOLD' }] : []),
                  ],
                  BLOCK_TYPE_BUTTONS: [
                    ...(controls.includes('ul') ? [{ label: 'UL', style: 'unordered-list-item' }] : []),
                    ...(controls.includes('ol') ? [{ label: 'OL', style: 'ordered-list-item' }] : []),
                  ],
                }}
              />
            }
            <Button
              variant="contained"
              disabled={errorText}
              style={{ marginTop: 20 }}
              color="primary"
              onClick={() => {
                submitTranslate(convertToText(dialogueValue));
                setValue(dialogueValue);
              }}
            >
              Сохранить
            </Button>
          </DialogContent>
        </Dialog>
      </Fragment>
    );
  } else {
    return displayOutput;
  }
}



// WEBPACK FOOTER //
// ./src/text/modal.js